import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import "./DashboardpagesCss/HomeCollectionHistory.css";
import nodatafound from "../../Assets/noDataFound.png";
import {
    getDownloadAllFile,
  getFinancialYear,
  getPastReport,
  getProfileStatus,
} from "../../api/api";
import { getUserMobile } from "../../utils/auth";
import toast from "react-hot-toast";
import { formatDate } from "../../utils/helper";
import JSZip from "jszip";
import { saveAs } from "file-saver";



const PastReportPage = () => {
  const { members } = useOutletContext();

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const formatDateChange = (date) => date.toISOString().split("T")[0];
  const defaultFromDate = formatDateChange(firstDayOfMonth);
  const defaultToDate = formatDateChange(today);

  const [financialYear, setFinancialYear] = useState("");
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [toDate, setToDate] = useState(defaultToDate);
  const [member, setMember] = useState("");
  const [data, setData] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedBill, setExpandedBill] = useState(null);

  const toggleExpand = (billId) => {
    setExpandedBill((prev) => (prev === billId ? null : billId));
  };

  // 🔹 Fetch profile list & financial year once
  useEffect(() => {
    fetchProfileListData();
    fetchFinancialYear();
  }, []);

  const fetchFinancialYear = async () => {
    try {
      const response = await getFinancialYear({ RBAuthKey: "RBDWAh!Q1s74e" });
      if (response?.data?.data) {
        setYears(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching financial year:", error);
    }
  };

  const fetchProfileListData = async () => {
    try {
      const mobile = getUserMobile();
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: "",
        mobile_no: mobile,
      };

      setLoading(true);
      const response = await getProfileStatus(payload);

      if (response?.data?.status === "success") {
        setProfileData(response.data.data || []);
      } else {
        toast.error(response?.data?.message || "Unable to fetch profile data");
      }
    } catch (error) {
      toast.error("Something went wrong while loading your profile.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Search & fetch past reports
  const handleSearch = async () => {
    try {
      setLoading(true);
      const mobile = getUserMobile();
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: member || "",
        mobile_no: mobile || "",
        From_date: formatDate(fromDate),
        To_date: formatDate(toDate),
        FYear: financialYear || "",
      };

      const response = await getPastReport(payload);
      // if (response?.data?.status === "success" && response?.data?.data?.length) {
      //     setData(response.data.data);
      // } else {
      //     toast.error(response?.data?.message || "No past reports found");
      //     setData([]);
      // }
      if (
        response?.data?.status === "success" &&
        response?.data?.data?.length
      ) {
        // Group by BillID
        const grouped = Object.values(
          response.data.data.reduce((acc, curr) => {
            if (!acc[curr.BillID]) {
              acc[curr.BillID] = {
                BillID: curr.BillID,
                BillDate: curr.BillDate,
                user_id: curr.user_id,
                PatientName: curr.PatientName,
                Bill_pdf_url: curr.Bill_pdf_url,
                report_image_url: curr.report_image_url,
                Prescription_pdf_url: curr.Prescription_pdf_url,
                tests: [],
              };
            }
            acc[curr.BillID].tests.push({
              TestName: curr.TestName,
              ReportStatus: curr.ReportStatus,
              report_image_url: curr.report_image_url,
              report_image_url_print: curr.report_image_url_print,
            });
            return acc;
          }, {})
        );

        setData(grouped);
      } else {
        toast.error("No past reports found");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching past reports:", error);
      toast.error("Something went wrong while fetching past reports.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

const handleDownloadAll = async (item) => {
  console.log("items are", item);
  try {
    toast.loading("Preparing all downloads...");

    // Build files list: include prescription & bill first, then include each test's report (prefer print URL)
    const files = [];
    if (item.Prescription_pdf_url) files.push({ name: "Prescription", url: item.Prescription_pdf_url });
    if (item.Bill_pdf_url) files.push({ name: "Bill", url: item.Bill_pdf_url });

    // include per-test report images/prints (use print version when available)
    if (Array.isArray(item.tests)) {
      item.tests.forEach((t, idx) => {
        const testUrl = t.report_image_url_print || t.report_image_url || t.report_image;
        if (testUrl) files.push({ name: `Report_${idx + 1}_${t.TestName || 'Test'}`, url: testUrl });
      });
    }

    // fallback: if no per-test files but a bill-level report url exists, include it
    if (files.length === 0 && item.report_image_url) {
      files.push({ name: "Pathology", url: item.report_image_url });
    }

    if (files.length === 0) {
      toast.dismiss();
      toast.error("No files available for download.");
      return;
    }

    const zip = new JSZip();

    for (const file of files) {
      const payload = { printUrl: file.url };
      const response = await getDownloadAllFile(payload);

      if (response?.data?.status === "success" && response?.data?.data) {
  const fileUrl = response.data.data;

  // response may return either a direct binary url or a base64/redirect — try to fetch
  const res = await fetch(fileUrl);
        const blob = await res.blob();

        // Detect actual type from blob
        let ext = "pdf"; // default
        const mime = blob.type.toLowerCase();
        if (mime.includes("jpeg") || mime.includes("jpg")) ext = "jpg";
        else if (mime.includes("png")) ext = "png";
        else if (mime.includes("pdf")) ext = "pdf";
        else {
          // Try fallback from URL
          const lowerUrl = fileUrl.toLowerCase();
          if (lowerUrl.endsWith(".jpg") || lowerUrl.endsWith(".jpeg")) ext = "jpg";
          else if (lowerUrl.endsWith(".png")) ext = "png";
        }

        // Add to zip with correct name
        zip.file(`${file.name}.${ext}`, blob);
      }
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveAs(zipBlob, `Reports_${item.BillID}.zip`);

    toast.dismiss();
    toast.success("All reports downloaded successfully!");
  } catch (error) {
    console.error("Download error:", error);
    toast.dismiss();
    toast.error("Failed to download all files.");
  }
};





  return (
    <div className="container">
      <div className="profile-header">
        <h2 className="rb-title pk-title package-tagg">Past Report</h2>
      </div>

      <div className="edit-profile-form-wrapper">
        {/* 🔹 Filters Section */}
        <div className="collection-history d-flex flex-wrap gap-3 align-items-end">
          <div>
            <label className="form-label collection-label">
              Financial Year
            </label>
            <select
              value={financialYear}
              onChange={(e) => setFinancialYear(e.target.value)}
              className="form-select select-form-view"
            >
              <option value="">-- Select Year --</option>
              {years.map((fy, index) => (
                <option key={index} value={fy?.FYear}>
                  {fy?.FYear}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="form-label collection-label">From Date*</label>
            <input
              type="date"
              className="form-control date-input"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label collection-label">To Date*</label>
            <input
              type="date"
              className="form-control date-input"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label collection-label">Member</label>
            <select
              value={member}
              onChange={(e) => setMember(e.target.value)}
              className="form-select select-form-view"
            >
              <option value="">-- Select Member --</option>
              {profileData.map((m, index) => (
                <option key={index} value={m.user_id}>
                  {m.PFirstName} {m.PLastName}
                </option>
              ))}
            </select>
          </div>

          <div className="btn-group-history">
            <button className="view-dash-btn" onClick={handleSearch}>
              <span className="btn-text">Proceed</span>
            </button>
          </div>
        </div>

        {/* 🔹 Helper Section */}
        <div className="history-middle-section">
          <p style={{ color: "#000000ff" }}>
            Unable to find all your past values?{" "}
            <a
              href="https://rbdiagnostic.com/mergereview"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontWeight: "bold", color: "#0FB7A4" }}
            >
              Click Here
            </a>
          </p>
        </div>

        {/* 🔹 Data Section */}
        <div className="history-area">
          {loading ? (
            <p style={{ textAlign: "center" }}>Loading...</p>
          ) : data.length === 0 ? (
            <div className="no-data">
              <img src={nodatafound} alt="No Data" />
            </div>
          ) : (
            <div className="table-wrapper">
            <table className="graph-table" >
              <thead>
                <tr>
                  <th>Sl. No</th>
                  <th>Bill ID</th>
                  <th>Bill Date</th>
                  <th>Prescription</th>
                  <th>Bill</th>
                  <th>Report</th>
                </tr>
              </thead>
        
              <tbody>
                {data.map((item, index) => (
                  <>
                    <tr key={item.BillID}>
                      <td>{index + 1}</td>
                      <td>{item.BillID}</td>
                      <td>{item.BillDate}</td>
                      <td>
                        {item.Prescription_pdf_url && (
                          <a
                            href={item.Prescription_pdf_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Prescription
                          </a>
                        )}
                      </td>
                      <td>
                        {item.Bill_pdf_url && (
                          <a
                            href={item.Bill_pdf_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Bill
                          </a>
                        )}
                      </td>
                      <td>
                        <button
                          className="view-btn"
                          onClick={() => toggleExpand(item.BillID)}
                        >
                          {expandedBill === item.BillID
                            ? "Hide Report"
                            : "View Report"}
                        </button>
                      </td>
                    </tr>

                    {expandedBill === item.BillID && (
                      <tr>
                        <td colSpan="6">
                          <div
                            style={{
                              background: "#ffffff",
                              borderRadius: "12px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                              margin: "15px 0",
                              overflow: "hidden",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                fontFamily: "Poppins, sans-serif",
                              }}
                            >
                              <thead>
                                <tr>
                                  {[
                                    "SL No",
                                    "Test Name",
                                    "Status",
                                    "Graph",
                                    "PACS",
                                    "Report Image",
                                    "View Report",
                                  ].map((header, i) => (
                                    <th
                                      key={i}
                                      style={{
                                        background: "#00b3a4",
                                        color: "white",
                                        padding: "10px 12px",
                                        textAlign: "left",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        borderBottom: "1px solid #00a095",
                                      }}
                                    >
                                      {header}
                                    </th>
                                  ))}

                                  {/* 🔹 Download All Reports column */}
                                  <th
                                    style={{
                                      background: "#00b3a4",
                                      color: "white",
                                      padding: "10px 12px",
                                      textAlign: "right",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      borderBottom: "1px solid #00a095",
                                    }}
                                  >
                                    <button
                                      style={{
                                        background: "#ffffff",
                                        color: "#00b3a4",
                                        border: "1px solid #00b3a4",
                                        borderRadius: "6px",
                                        padding: "6px 14px",
                                        cursor: "pointer",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        transition: "all 0.3s ease",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.background = "#00b3a4";
                                        e.target.style.color = "#fff";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.background = "#fff";
                                        e.target.style.color = "#00b3a4";
                                      }}
                                     onClick={() => handleDownloadAll(item)}
                                    >
                                      ⬇️ Download All
                                    </button>
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {item.tests.map((test, i) => (
                                  <tr
                                    key={i}
                                    style={{
                                      background:
                                        i % 2 === 0 ? "#f8fdfd" : "#ffffff",
                                      transition: "background 0.3s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.background =
                                        "#e9f9f8")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.background =
                                        i % 2 === 0 ? "#f8fdfd" : "#ffffff")
                                    }
                                  >
                                    {/* SL No */}
                                    <td
                                      style={{
                                        padding: "10px 12px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {i + 1}
                                    </td>

                                    {/* Test Name */}
                                    <td
                                      style={{
                                        padding: "10px 12px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {test.TestName}
                                    </td>

                                    {/* Status */}
                                    <td
                                      style={{
                                        padding: "10px 12px",
                                        fontSize: "14px",
                                        color:
                                          test.ReportStatus === "Completed"
                                            ? "#22c55e"
                                            : test.ReportStatus === "Pending"
                                            ? "#f59e0b"
                                            : "#000",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {test.ReportStatus}
                                    </td>

                                    {/* Graph */}
                                    <td style={{ padding: "10px 12px" }}>
                                      <button
                                        // onClick={() => handleGraphOpen(test)} // graph modal
                                        style={{
                                          background: "#eefcfb",
                                          color: "#00b3a4",
                                          border: "1px solid #00b3a4",
                                          borderRadius: "6px",
                                          padding: "5px 12px",
                                          cursor: "pointer",
                                          fontSize: "13px",
                                          fontWeight: 500,
                                          transition: "all 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.background = "#00b3a4";
                                          e.target.style.color = "#fff";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.background = "#eefcfb";
                                          e.target.style.color = "#00b3a4";
                                        }}
                                      >
                                        View Graph
                                      </button>
                                    </td>

                                    {/* PACS */}
                                    <td style={{ padding: "10px 12px" }}>
                                      {test.pacs_url ? (
                                        <a
                                          href={test.pacs_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            background: "#00b3a4",
                                            color: "white",
                                            borderRadius: "6px",
                                            padding: "6px 14px",
                                            cursor: "pointer",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            textDecoration: "none",
                                            display: "inline-block",
                                            transition: "background 0.3s ease",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.target.style.background =
                                              "#00998b")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.target.style.background =
                                              "#00b3a4")
                                          }
                                        >
                                          View PACS
                                        </a>
                                      ) : (
                                        "-"
                                      )}
                                    </td>

                                    {/* Report Image */}
                                    <td
                                      style={{
                                        padding: "10px 12px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {test.report_image_url ? (
                                        <a
                                          href={test.report_image_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            color: "#00b3a4",
                                            textDecoration: "none",
                                            fontWeight: 500,
                                          }}
                                        >
                                          View Image
                                        </a>
                                      ) : (
                                        "-"
                                      )}
                                    </td>

                                    {/* View Report */}
                                    <td style={{ padding: "10px 12px" }}>
                                      {test.report_image_url_print ? (
                                        <a
                                          href={test.report_image_url_print}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            background: "#00b3a4",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "6px",
                                            padding: "6px 14px",
                                            cursor: "pointer",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            textDecoration: "none",
                                            display: "inline-block",
                                            transition: "background 0.3s ease",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.target.style.background =
                                              "#00998b")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.target.style.background =
                                              "#00b3a4")
                                          }
                                        >
                                          Open Report
                                        </a>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PastReportPage;
